import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aadca86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-next-competition" }
const _hoisted_2 = { class: "container pb-7" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-lg-8 mb-3 mb-lg-0" }
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = {
  class: "position-absolute w-50 end-0 bottom-0 mb-n3",
  style: {"right":"40px"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card rounded bg-soft-primary h-100 overflow-hidden mt-7" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "w-65 pe-2" }
const _hoisted_11 = { class: "card-title" }
const _hoisted_12 = { class: "card-text text-body" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-chevron-right small ms-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "card-img runner-image",
                src: _ctx.nextCompetitionImg
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.t('home.nextCompetition.title')), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t('home.nextCompetition.text')), 1),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToNextCompetitions && _ctx.goToNextCompetitions(...args))),
                    class: "btn rounded-pill btn-soft-primary btn-sm"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.t('home.nextCompetition.button')) + " ", 1),
                    _hoisted_13
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}